import { render, staticRenderFns } from "./productform.vue?vue&type=template&id=c4dd9090&scoped=true&"
import script from "./productform.vue?vue&type=script&lang=js&"
export * from "./productform.vue?vue&type=script&lang=js&"
import style0 from "./productform.vue?vue&type=style&index=0&id=c4dd9090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dd9090",
  null
  
)

export default component.exports